* {
  box-sizing: border-box;
}

.progress-container-thin {
  height: var(--spacer);
  background-color: var(--chart-050-hover);
  position: relative;
  width: 100%;
  border-radius: 8px;

  .progress-thin {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 100%;
    border-radius: var(--spacer);
  }
}

:host([animations]) {
  .progress-container-thin {
    .progress-thin {
      transition: width 0.5s cubic-bezier(0.37, 0.11, 0.83, 0.67);
    }
  }
}
